// extracted by mini-css-extract-plugin
export default {"container":"NoDocumentsNotification_container__6TuhU"};